angular.module('jv.Admin.Users.Administration.Service', [
        'jv.Admin.Users.Ajax.Factory',
        'jv.Admin.Users.PostParams.Factory',
        'jv.Common.Jobvite.Urls'
    ])
    .factory('jvAdminUsersAdministrationAjaxConstant', ['$window', '$jobviteUrls', function($window, $jobviteUrls) {
        return {
            Urls: {
                "getRole": $jobviteUrls.admin + '/action/user-details/user/{0}/roles',
                "getPermissionsByDomain": $jobviteUrls.admin + '/action/user-details/user/{0}/permissions?domain={1}',
                "getPermissions": $jobviteUrls.admin + '/action/user-details/user/{0}/permissions',
            }
        };
    }])
    .service('jvAdminUsersAdministrationService', ['prepareAjaxCall', 'jvAdminUsersAdministrationAjaxConstant', '$window',
        function(prepareAjaxCall, jvAdminUsersAdministrationAjaxConstant, $window) {
            this.getRole = function(params, callback, fail) {
                var options = {
                    "ajaxtype": "getRole",
                    "url": jvAdminUsersAdministrationAjaxConstant.Urls.getRole.format(params.email),
                };
                delete params.email;
                prepareAjaxCall(params, options, callback, fail);
            };

            this.getPermissions = function(params, callback, fail) {
                var options = {
                    "ajaxtype": "getPermissions",
                    "url": jvAdminUsersAdministrationAjaxConstant.Urls.getPermissions.format(params.email),
                }
                delete params.email;
                delete params.domain;
                prepareAjaxCall(params, options, callback, fail);
            };
            
            this.getPermissionsByDomain = function(params, callback, fail) {
                var options = {
                    "ajaxtype": "getPermissionsByDomain",
                    "url": jvAdminUsersAdministrationAjaxConstant.Urls.getPermissionsByDomain.format(params.email, params.domain),
                }
                delete params.email;
                delete params.domain;
                prepareAjaxCall(params, options, callback, fail);
            };
        }
    ]);
